<template>
  <div id="login-view">
    <head>
      <meta name="description" content="Securely log in to your account. Access your profile and manage your information. Stay connected with our platform">
    </head>
    <b-overlay>
      <section class="bg-login ftco-section">
        <div class="d-flex justify-content-center">
          <img src="@/assets/site/images/loader.gif" v-if="loader===true" class="img-fluid  loader-width" alt />
        </div>
        <div class="container" v-if="loader===false">
          <div class="row d-flex justify-content-center">
            <div class="col-md-7 ">
              <div style="margin-top: 2rem">
                <div class="card-body bg-dark-gray">
                  <h1 class="text-black display-4 my-4">Login</h1>
                  <form>
                    <label for="">E-mail</label>
                    <div class="form-group">
                      <input type="text" class="form-control" v-model="email" placeholder="Email Address" />
                      <span class="text-danger" v-if="errors.email">{{
                        this.errors.email[0]
                      }}</span>
                    </div>
                    <label for="">password*</label>
                    <div class="form-group">
                      <input type="password" class="form-control" v-model="password" placeholder="Password" />
                      <span class="text-danger" v-if="errors.password">{{
                        this.errors.password[0]
                      }}</span>
                    </div>
                    <div class="row">
                      <div class="col-8">
                        <span class="text-danger">{{ error_msg }}</span>
                      </div>
                    </div>
                    <div class="row mb-1">
                      <!-- /.col -->
                      <div class="col-7 mt-4 mb-2">
                        <button @click="login" type="button" class="btn btn-light1 btn-block px-4">
                          submit
                        </button>
                      </div>
                    </div>
                    <div class="row d-flex justify-content-between">
                      <div class="col-md-5">
                        <p >
                          <router-link  to="/site/signup" class="text3" >Don’t have an account? </router-link>
                        </p>
                      </div>
                      <div class="col-md-3">
                        <router-link class="text3-c" to="/site/signup" > Sign Up</router-link>
                      </div>
                      <div class="col-md-4">
                        <router-link to="/site/forgot" class="text3-c" >Forgot Password?</router-link>
                      </div>
                    </div>
                    <!-- /.col -->
                  </form>
                </div>
                <!-- /.login-card-body -->
              </div>
            </div>
          </div>
        </div>
      </section>
    </b-overlay>
  </div>
</template>

<script>
    export default {
        name: "LoginView",
        data() {
            return {
                email: null,
                password: null,
                errors: [],
                error_msg: null,
                loader: false,
                redirect_link: ""
            };
        },
          created() {
          let parameters = this.$route.query
          console.log(parameters)
          // if(parameters === undefined){
            this.redirect_link = this.$route.query.redirect
          // }
          console.log(this.redirect_link)
          var loc_UserData = localStorage.getItem("userData");
          let userData = JSON.parse(loc_UserData);
          if(this.redirect_link == "" || this.redirect_link == null){
          //clear user data
            if( userData != null){
              localStorage.clear();
              window.location.href = "/site";
            }
          } else {
            if( userData != null){
              localStorage.removeItem("userData");
              window.location.href = "/site?redirect=checkout";
            }
          }
          localStorage.setItem("redirectLink", JSON.stringify(this.redirect_link));
        },
        methods: {
            login() {
                //Save or update User Details
                this.errors = [];
                this.error_msg = null;
                this.loader = true;
                let apiUrl = process.env.VUE_APP_URL + "api/login";
                let method_type = "post";
                fetch(apiUrl, {
                        method: method_type,
                        headers: {
                            "content-type": "application/json",
                            "X-Requested-With": "XMLHttpRequest",
                        },
                        body: JSON.stringify({
                            email: this.email,
                            password: this.password,
                        }),
                    })
                    .then((res) => res.json())
                    .then((data) => {
                        if (data.status === true) {
                            var userData = {
                                user: data.user,
                                token: data.token,
                                status: true
                            };
 
                            localStorage.setItem("userData", JSON.stringify(userData));
                            if (userData.user.role !== 'User') {
                                window.location.href = "admin";
                            } else {
                            console.log(this.redirect_link );
                              if(this.redirect_link == "checkout"){
                                let cartUrl = this.redirect_link;
                                this.redirect_link = "";
                                localStorage.removeItem("redirectLink");
                                window.location.href = data.oc_login_link+"&redirectlink=" + cartUrl; 
                              }else{
                                localStorage.setItem("oc_login_link", JSON.stringify(data.oc_login_link));
                                window.location.href = "/user/dashboard";
                              }
                            }

                        } else if (data.status === false) {
                            localStorage.clear();
                            this.loader = false;
                            this.error_msg = data.message;
                        } else {
                            this.loader = false;
                            this.errors = data.errors;
                        }
                    })
                    .catch(function(err) {
                        console.log("User Data", "Error : " + err.message, "error");
                    });
            },
        },
    };
</script>